import { Gem, Atom, Droplet, Citrus, Leaf, Layers } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";

const INGREDIENTS = [
  {
    icon: Gem,
    name: "24K Gold",
    copy: "The signature touch — a luminous, luxurious finish to every ritual.",
    span: "md:col-span-2",
    img: "https://images.unsplash.com/photo-1765859904394-73fd39f97c41",
  },
  { icon: Atom, name: "Collagen", copy: "A skincare classic that helps skin feel smooth and supple." },
  { icon: Droplet, name: "Hyaluronic Acid", copy: "A hydration hero that helps skin hold onto moisture." },
  {
    icon: Citrus,
    name: "Vitamin C",
    copy: "Beloved for helping skin look bright and fresh.",
    img: "https://images.unsplash.com/photo-1638011921488-13a67c045aa6",
  },
  {
    icon: Leaf,
    name: "Aloe Vera",
    copy: "A gentle, soothing botanical loved by sensitive skin.",
    img: "https://images.pexels.com/photos/8205507/pexels-photo-8205507.jpeg",
  },
  { icon: Layers, name: "Ceramides", copy: "Help support the skin's natural moisture barrier." },
];

export const Ingredients = () => (
  <section id="ingredients" className="py-24 md:py-32" data-testid="ingredients-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        eyebrow="Inside The Jar"
        title={<>Thoughtfully chosen <span className="italic gold-text">ingredients</span></>}
        copy="Every patch is infused with a serum blend of skin-loving ingredients."
      />
      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
        {INGREDIENTS.map((ing, i) => (
          <Reveal key={ing.name} delay={i * 0.06} className={ing.span || ""}>
            <div
              data-testid={`ingredient-card-${ing.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative h-full min-h-[220px] overflow-hidden rounded-2xl border border-champagne/70 bg-white p-7 transition-[box-shadow,transform] duration-500 hover:shadow-[0_16px_40px_rgb(201,162,39,0.10)] hover:-translate-y-1"
            >
              {ing.img && (
                <>
                  <img
                    src={ing.img}
                    alt=""
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover opacity-[0.16] transition-opacity duration-500 group-hover:opacity-[0.24]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-white via-white/70 to-white/30" />
                </>
              )}
              <div className="relative">
                <ing.icon size={30} strokeWidth={1} className="text-gold-deep" />
                <h3 className="mt-5 font-display text-2xl text-ink">{ing.name}</h3>
                <p className="mt-2 text-sm text-[#5C5C5C] leading-relaxed">{ing.copy}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
